import { render, staticRenderFns } from "./ver_historial.vue?vue&type=template&id=0fa81833&scoped=true"
import script from "./ver_historial.vue?vue&type=script&lang=js"
export * from "./ver_historial.vue?vue&type=script&lang=js"
import style0 from "./ver_historial.vue?vue&type=style&index=0&id=0fa81833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa81833",
  null
  
)

export default component.exports